import { RiskSeverity } from '@/types';

// Exposure severity is excluded from counts — its weight is 0 and it is not scored
export interface SeverityCounts {
  [RiskSeverity.Critical]: number;
  [RiskSeverity.High]: number;
  [RiskSeverity.Medium]: number;
  [RiskSeverity.Low]: number;
  [RiskSeverity.Info]: number;
}

export const SEVERITY_WEIGHTS: Record<RiskSeverity, number> = {
  [RiskSeverity.Critical]: 10,
  [RiskSeverity.High]: 4,
  [RiskSeverity.Medium]: 1,
  [RiskSeverity.Low]: 0.25,
  [RiskSeverity.Info]: 0,
  [RiskSeverity.Exposure]: 0,
};

const KNOWN_SEVERITIES = new Set<string>([
  RiskSeverity.Critical,
  RiskSeverity.High,
  RiskSeverity.Medium,
  RiskSeverity.Low,
  RiskSeverity.Info,
]);

/**
 * Extracts the RiskSeverity from a risk status string.
 * The status string format is <RiskStatus><RiskSeverity>... (e.g. "OH" = Opened High).
 * The severity is the second character (index 1).
 */
export function extractSeverityFromStatus(status: string): RiskSeverity | null {
  if (status.length < 2) return null;
  const severityChar = status[1];
  if (KNOWN_SEVERITIES.has(severityChar)) {
    return severityChar as RiskSeverity;
  }
  return null;
}

export function emptyCounts(): SeverityCounts {
  return {
    [RiskSeverity.Critical]: 0,
    [RiskSeverity.High]: 0,
    [RiskSeverity.Medium]: 0,
    [RiskSeverity.Low]: 0,
    [RiskSeverity.Info]: 0,
  };
}

export function computeScore(counts: SeverityCounts): number {
  return (
    counts[RiskSeverity.Critical] * SEVERITY_WEIGHTS[RiskSeverity.Critical] +
    counts[RiskSeverity.High] * SEVERITY_WEIGHTS[RiskSeverity.High] +
    counts[RiskSeverity.Medium] * SEVERITY_WEIGHTS[RiskSeverity.Medium] +
    counts[RiskSeverity.Low] * SEVERITY_WEIGHTS[RiskSeverity.Low] +
    counts[RiskSeverity.Info] * SEVERITY_WEIGHTS[RiskSeverity.Info]
  );
}
